import { useEffect } from "react";
import { setupNetwork } from "../utils/wallet";
import { useWeb3React } from "@web3-react/core";

const useAutoChainSwitch = (desiredChainId = 1) => {
  const { account, chainId } = useWeb3React();
  console.log(chainId, "chainId");

  const chainSwitch = async () => {
    await setupNetwork(desiredChainId);
  };

  useEffect(() => {
    const currentChainId = chainId;
    if (currentChainId && parseInt(currentChainId) !== desiredChainId) {
      chainSwitch();
    }
  }, [desiredChainId, chainId]);
};

export default useAutoChainSwitch;
